import { useRef } from "react";
import {
  Button,
  SlideOutModal,
  SlideOutModalProps,
} from "../../../components";
import * as yup from "yup";
import { Formik } from "formik";
import { Form, Row, Col, FloatingLabel, Button as BSButton } from "react-bootstrap";
import { TenantModel } from "../../../data/entities";
import { sharedProperty } from "../../../hooks";

export interface AddTenantModalProps extends SlideOutModalProps {
  showAddState: sharedProperty<boolean>;
  onSubmit: any;
}

export function AddTenantModal(props: Readonly<AddTenantModalProps>) {

  const submitRef = useRef<HTMLButtonElement>(null);

  const validationSchema = yup.object().shape({
    name: yup.string().required("Tenant Name is required")
  });

  return (
    <SlideOutModal
      {...props}
      title="Add New Tenant"
      footer={
        <div className="container p-0">
          <div className="row g-0">
            <div className="col-12 pe-2">
              <Button onClick={() => props.showState.setter(false)} variant="cancel" className="w-100">
                Cancel
              </Button>
            </div>
            <div className="col-12 ps-2">
              <Button onClick={() => submitRef.current?.click()} variant="primary" className="w-100">
                Add
              </Button>
            </div>
          </div>
        </div>
      }
    >
      <Formik
        validationSchema={validationSchema}
        initialValues={{
          name: ''
        }}
        onSubmit={async (values) => {
          const organization = {
            ...values
          } as TenantModel;
          props.onSubmit(organization);
          props.showAddState.setter(false);
        }}
      >
        {({ values, handleSubmit, handleChange, setFieldValue, touched, errors }) => {
          return (
            <Form onSubmit={handleSubmit}>
              <Row>
                <Col>
                  <FloatingLabel label="Tenant Name" className="mb-3">
                    <Form.Control
                      type="text"
                      name="name"
                      placeholder="Tenant Name"
                      value={values.name}
                      onChange={handleChange}
                      isInvalid={touched.name && !!errors.name}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.name}
                    </Form.Control.Feedback>
                  </FloatingLabel>
                </Col>
              </Row>

              <BSButton ref={submitRef} type="submit" size="lg" className="d-none" />
            </Form>
          )
        }}
      </Formik>
    </SlideOutModal>
  );
}

export default AddTenantModal;
